import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        if (!this.props.stories) {
            this.props.requireState(this.props.limit);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.stories != this.props.stories) {
            return true;
        }

        return false;
    }

    render({ stories }) {
        if (stories) {
            return (
                <hexagram-content className='container' {...this.props}>
                    <h1 className='has-margin-10-left-mobile'>More About I Ching Hexagrams</h1>
                    <p className='has-margin-10-left-mobile'>
                        Learn about the history of the I Ching and how to use the ancient Chinese oracle to receive
                        powerful guidance and get a deeper understanding of any situation.
                    </p>
                    <row className='is-wrap'>
                        {stories.map(this.renderStory)}
                    </row>
                </hexagram-content>
            );
        }

        return (<hexagram-content {...this.props} />);
    }

    renderStory = (story) => {
        if (story) {
            const alt = story.image_alt || story.title;
            const src = `https://gfx.tarot.com/images/feeds/${this.props.img_size}/${story.picture_frag}-${this.props.img_size}.jpg`; //eslint-disable-line max-len

            return (
                <column className='is-12-mobile is-6'>
                    <hexagram-content-story>
                        <a
                            className='promoted_content_link'
                            href={story.url}
                            title={story.title}
                        >
                            <img alt={alt} className='promoted_content_img' src={src} />
                            <p className='text-center' dangerouslySetInnerHTML={{__html: story.title}} />
                        </a>
                    </hexagram-content-story>
                </column>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    stories: state.content && state.content.hexagram,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: (limit) => dispatch({ type: 'content:fetchHexagram', payload: limit }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
